import Vue from 'vue'
import App from './App.vue'
import VueExcelEditor from 'vue-excel-editor'
import vuetify from './plugins/vuetify'
import PrimeVue from 'primevue/config'
import store from './store'
import router from './router'
import Vuelidate from 'vuelidate'
import VueToastr from '@deveodk/vue-toastr'
import VueTheMask from 'vue-the-mask'
import Tooltip from 'primevue/tooltip'
import i18n from './i18n'
import './assets/styles/index.scss'

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ru-RU'
import 'element-ui/lib/theme-chalk/index.css'

import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'
import 'primevue/resources/themes/saga-blue/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'
import './assets/styles/index.scss'

Vue.config.productionTip = false

Vue.use(VueExcelEditor)
Vue.use(PrimeVue)
Vue.use(Vuelidate)
Vue.use(VueToastr, {
  defaultPosition: 'toast-bottom-right',
  defaultType: 'info',
  defaultTimeout: 5500
})
Vue.use(VueTheMask)
Vue.use(ElementUI, { locale })

Vue.use(PrimeVue, { ripple: true })
Vue.directive('tooltip', Tooltip)

new Vue({
  vuetify,
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
